import { images } from "@/data/resort";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function RatesIntro() {
  return (
    <section
      id="overview"
      aria-labelledby="rates-intro-heading"
      className="bg-background pb-16 pt-26 md:pb-20 md:pt-28"
    >
      <div className="shell">
        <div className="grid items-center gap-10 lg:grid-cols-12 lg:gap-10">
          <div className="lg:col-span-6">
            <Reveal>
              <Eyebrow>Simple Options</Eyebrow>
            </Reveal>
            <h2 id="rates-intro-heading" className="display-lg mt-6 max-w-[18ch]">
              <MaskReveal>Choose the Stay That</MaskReveal>
              <MaskReveal delay={0.08}>Fits Your Journey</MaskReveal>
            </h2>
            <Reveal delay={0.12}>
              <p className="mt-8 max-w-xl text-base leading-relaxed text-muted-foreground md:text-[1.05rem]">
                Rates at Auburn RV Resort vary depending on site size, location and availability.
                Whether you&apos;re passing through Auburn or planning a longer stay in the Sierra
                Foothills, our team can help you find the right site and current rate for your
                travel plans.
              </p>
            </Reveal>
            <Reveal delay={0.18}>
              <div className="mt-10 flex w-full flex-col gap-3 sm:flex-row sm:flex-wrap">
                <ResortLink variant="solid" href="/reservations/" className="w-full sm:w-auto">
                  Check Availability
                </ResortLink>
                <ResortLink variant="outline" href="/accommodations/" className="w-full sm:w-auto">
                  Explore Our RV Sites
                </ResortLink>
              </div>
            </Reveal>
          </div>

          <Reveal className="lg:col-span-6" y={36}>
            <img
              src={images.amenityHookups}
              alt="Full-hookup RV lifestyle stay at Auburn RV Resort"
              width={1200}
              height={1400}
              loading="lazy"
              decoding="async"
              className="aspect-[4/5] w-full object-cover"
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
